import React from 'react';
import { PhotoThumbnail } from '../PhotoThumbnail';
import * as S from './PhotoTableCellContent.styled';
export const PhotoTableCellContent = ({ name, description, photo, photoSize, }) => (React.createElement(S.Container, null,
    React.createElement(S.ImageContainer, null,
        React.createElement(PhotoThumbnail, { url: photo, size: photoSize })),
    React.createElement(S.NameContainer, null,
        React.createElement(S.Name, null, name),
        description && React.createElement(S.Description, null, description))));
